import fr from "./lang/fr/swiziReception.json";
import en from "./lang/en/swiziReception.json";

const langs = {
  fr: {
    translation: fr,
  },
  en: {
    translation: en,
  },
};

export default langs;
